"use client"

import { RouteErrorState } from "@/components/shared/route-error-state"

export default function ProductError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}): React.ReactNode {
  return (
    <RouteErrorState
      description='Ocorreu um erro ao carregar os dados do produto. Tente novamente.'
      error={error}
      reset={reset}
      title='Nao foi possivel carregar este produto'
    />
  )
}
